import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 10,
    width: '100%',
    maxWidth: 800
  },
  row: {
    flexDirection: 'row'
  },
  leftItem: {
    flex: 1,
    width: '100%',
    marginRight: 5
  },
  rightItem: {
    flex: 1,
    marginLeft: 5
  },
  subtitle: {
    marginBottom: 15
  }
})

export default styles
